import { GetDeliveryListService, GetDeliveryListBySearchBarService } from "../Infrastructure/Delivery.service";

export async function GetDeliveryListLogic(zone) {
  return await GetDeliveryListService(zone);
}

export async function GetDeliveryListBySearchBarLogic(zone, name){
  return await GetDeliveryListBySearchBarService(zone, name);
}